import { useEffect } from 'react';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { ResetBtn, UseBtn } from 'libs/ui';
import { RoleFilter, DateSelect, Container, Input, DoubleField, DateTime, ButtonsContainer } from 'libs/form';

const initialValues = {
  timestamp_from: moment().startOf('day').format(),
  timestamp_to: moment().endOf('day').format(),
};

const ActionFilter = (props) => {
  const { setInitial, reset, handleSubmit, change, theme } = props;

  const { t } = useTranslation();

  // did mount
  useEffect(() => {
    setInitial(initialValues);
    return () => {
      reset();
      setInitial(initialValues);
    };
  }, []);

  return (
    <Container theme={theme}>
      <form onSubmit={handleSubmit}>
        <DateSelect from_name="timestamp_from" to_name="timestamp_to" change={change}>
          <DoubleField>
            <DateTime width="160px" name="timestamp_from" type="dateTime" label={t('grid.Дата и время')} />
            <DateTime width="160px" name="timestamp_to" type="dateTime" />
          </DoubleField>
        </DateSelect>

        <RoleFilter name="role_id" multiple />

        <Input width="290px" name="name" type="text" label={t('inputs.Пользователь')} placeholder={t('form.Иванов И.И.')} />

        <Input width="230px" name="action" type="text" label={t('inputs.Описание')} placeholder={t('inputs.Введите название')} lastField />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'actionFilter',
  // destroyOnUnmount: false,
  initialValues: initialValues,
})(ActionFilter);
